import type { DecimalInput } from './exactDecimal.js';
import { UNIVERSAL_UNITS, unitDefinition, compatibleUnits, convertUnitExact, type UnitDimension } from './unitSystem.js';
export const RECIPE_PORTION_UNITS = UNIVERSAL_UNITS;
export type RecipeMeasureUnit = typeof RECIPE_PORTION_UNITS[number];
export type RecipeMeasureDimension = UnitDimension;

export function normalizedRecipeMeasureUnit(value: string): RecipeMeasureUnit | null { return unitDefinition(value)?.code ?? null; }
export function recipeMeasureDimension(value: string): RecipeMeasureDimension | null { return unitDefinition(value)?.dimension ?? null; }
export function compatibleRecipePortionUnits(yieldUnit: string): RecipeMeasureUnit[] { return compatibleUnits(yieldUnit); }
export function defaultRecipePortionUnit(yieldUnit: string): RecipeMeasureUnit {
  const dimension = recipeMeasureDimension(yieldUnit);
  return dimension === 'MASS' ? 'oz' : dimension === 'COUNT' ? 'piece' : 'fl oz';
}
export function convertRecipeMeasure(value: number, fromUnit: string, toUnit: string): number | null {
  const converted = convertRecipeMeasureExact(value, fromUnit, toUnit);
  return converted === null ? null : Number(converted);
}
export const convertRecipeMeasureExact = (value: DecimalInput, fromUnit: string, toUnit: string): string | null => convertUnitExact(value, fromUnit, toUnit);
export function recipeMeasureLabel(unit: RecipeMeasureUnit, locale: 'en' | 'es') { return unitDefinition(unit)?.label[locale] ?? unit; }
